import { render } from "./slide27.vue?vue&type=template&id=7fa1907e&scoped=true"
import script from "./slide27.vue?vue&type=script&lang=js"
export * from "./slide27.vue?vue&type=script&lang=js"

import "./slide27.vue?vue&type=style&index=0&id=7fa1907e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa1907e"]])

export default __exports__